module.exports = __webpack_public_path__ + "static/media/sunset_11.69688a52.webp";